import React from 'react';
import ScoreCard from './ScoreCard';
import ProbabilityCards from './ProbabilityCards';
import AnalysisGrid from './AnalysisGrid';
import SummaryCard from './SummaryCard';
import GeoInfo from './GeoInfo';
import WafInfo from './WafInfo';

export default function ResultsPanel({ results }) {
  const { url, score, classification, probabilities, checks, summary, urlParts, geoLocation, dnsAddresses, wafDetection } = results;

  return (
    <section className="results-section">
      {/* IP & Geolocation */}
      <GeoInfo geoLocation={geoLocation} dnsAddresses={dnsAddresses || []} />

      {/* WAF Detection */}
      <WafInfo wafDetection={wafDetection} />

      {/* Score Overview */}
      <div className="score-overview">
        <ScoreCard score={score} classification={classification} />
        <ProbabilityCards probabilities={probabilities} />
      </div>

      {/* Analysis Details */}
      <AnalysisGrid checks={checks} />

      {/* Summary */}
      <SummaryCard summary={summary} classification={classification} />
    </section>
  );
}
